import { useEffect, useState } from "react";
import axios from "axios";
import Footer from "../../../../../components/Footer/Footer";
import InnerNav from "../../../../../components/InnerNav/InnerNav";
import { useFormData } from '../../ContextData/ContextData';
import "./yogini.scss";

export default function YoginiDasha() {
  const { userData } = useFormData();
  const [dashaData, setDashaData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await axios.get(
          "https://core-c343.onrender.com/api/yogini-dasha",
          {
            params: {
              year: userData.year,
              month: userData.month,
              day: userData.day,
              hour: userData.hour,
              minute: userData.minute,
            },
          }
        );
        setDashaData(res.data);
      } catch (err) {
        console.error("Error fetching Yogini Dasha:", err);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  // Helper: Parse antarDasha into structured format
  const parseAntarDasha = (antarList) => {
    const structured = [];
    let current = null;

    antarList.forEach((line) => {
      if (line.startsWith("------------------------")) {
        if (current) structured.push(current);
        const cleaned = line.replace(/[-\n]/g, "").trim();
        const parts = cleaned.split(" ");
        const planet = parts[0] || "";
        const years = parts[1] ? parts[1] + " " + (parts[2] || "") : "";
        current = { planet, years, sub: [] };
      } else if (current) {
        current.sub.push(line);
      }
    });

    if (current) structured.push(current);
    return structured;
  };

  if (loading) return <p>Loading Yogini Dasha...</p>;
  if (!dashaData) return <p>No data available</p>;

  const antarStructured = parseAntarDasha(dashaData.antarDasha);

  return (
    <div className="yogini-dasha-container">
      <InnerNav />
      <h1 className="yogini-dasha-title">Yogini Dasha</h1>

      <p className="yogini-dasha-moon">
        🌙 Moon Sign: <strong>{dashaData.moonSign}</strong>
      </p>
      <p className="yogini-dasha-birth">
        📅 Birth Date: <strong>{dashaData.birthDate}</strong>
      </p>

      {/* Summary Section */}
      <div className="yogini-dasha-summary">
        <h2>Main Periods (Summary)</h2>
        <div className="yogini-dasha-grid">
          {dashaData.summary.map((s, idx) => (
            <div key={idx} className="yogini-dasha-summary-item">
              <p>{s}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Antar Dasha Section */}
      <div className="yogini-dasha-antar">
        <h2>Antar Dasha (Sub Periods)</h2>
        <div className="yogini-dasha-grid">
          {antarStructured.map((block, idx) => (
            <div
              key={idx}
              className={`yogini-dasha-column ${idx === 0 ? "highlight" : ""}`}
            >
              <p className="yogini-dasha-header">-------------</p>
              <p className="yogini-dasha-header">
                {block.planet} - {block.years}
              </p>
              <p className="yogini-dasha-header">-------------</p>

              {block.sub.map((s, i) => (
                <p key={i}>{s}</p>
              ))}
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
}
